import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { Loading, Alert } from 'Components/Partials';
import { PrimaryButton } from 'Components/Button';
import { FormHandler, Label } from 'Components/Form';
import ReactSelect from 'react-select';
import Authenticated from "Components/Layouts/Authenticated";
import SurveyAPI from "Services/Api/Survey/Survey";
import { User } from "Services";

class Survey extends Component {

    surveyOneQuestions = [
        { id: 1, type: 'numericTen', text: 'What was your overall experience of the Bupa Symposium?', survey: 'survey_one' },
        {
            id: 2,
            type: 'eventValue',
            text: 'What part of the event was of the most value to you?',
            survey: 'survey_one',
            options: [
                { value: 'conversations and connections made', label: 'Conversations and Connections Made' },
                { value: 'content of the presentations', label: 'Content of the Presentations' },
                { value: 'visiting the exhibition', label: 'Visiting the Exhibition' },
            ]
        },
        {
            id: 3,
            type: 'eventValue',
            text: 'How many new connections did you make during the event?',
            survey: 'survey_one',
            options: [
                { value: 'none', label: 'None' },
                { value: 'less than 5', label: 'Less than 5' },
                { value: 'between 6-10', label: 'Between 6-10' },
                { value: 'over 10', label: 'Over 10' },
            ]
        },
        { id: 4, type: 'text', text: 'How will the connections you have made or what you have learnt influence your work or future decision making?', survey: 'survey_one' },
        { id: 5, type: 'text', text: 'What could we do to improve the impact of future Symposiums?', survey: 'survey_one' },
        {
            id: 6,
            type: 'eventValue',
            text: 'How did you feel about the level of communication prior to the event?',
            survey: 'survey_one',
            options: [
                { value: 'too much', label: 'Too Much' },
                { value: 'about right', label: 'About Right' },
                { value: 'not enough', label: 'Not Enough' },
            ]
        },
    ];

    surveyTwoQuestions = [
        { id: 1, type: 'numericTen', text: 'What was your overall experience of the Bupa Symposium?', survey: 'survey_two' },
        { id: 2, type: 'text', text: 'How will the content presented influence your work or future decision making?', survey: 'survey_two' },
        { id: 3, type: 'text', text: 'What could we do to improve the impact of future Symposiums?', survey: 'survey_two' },
        {
            id: 4,
            type: 'eventValue',
            text: 'How did you feel about the level of communication prior to the event?',
            survey: 'survey_two',
            options: [
                { value: 'too much', label: 'Too Much' },
                { value: 'about right', label: 'About Right' },
                { value: 'not enough', label: 'Not Enough' },
            ]
        },
    ];

    /**
     * @var state
     * @type {{loading: boolean, show: boolean, submission: boolean}}
     */
    state = {
        loading: false,
        submission: false,
        question: 1,
        selectedSurvey: null,
        survey_type: this.props.match.params.type === 'virtual' ? 'survey_two' : 'survey_one',
        userType: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        this.props.setInitialValues({
            results: [],
        });

        this.setState({
            selectedSurvey: this.props.match.params.type === 'virtual' ? this.surveyTwoQuestions : this.surveyOneQuestions,
        });
    };

    /**
     * @method success
     */
    success = () => {
        this.setState({
            submission: true,
        });
    };

    /**
     * @method updateResults
     * @param {string} question
     * @param {string} answer
     */
    updateResults = (question, answer) => {
        const { handleInput, form } = this.props;

        let new_results = {};

        if (form.results) {
            new_results = {
                ...form.results,
            }
        }

        new_results[question] = answer;

        handleInput('results', new_results);
    }

    /**
     * @method storeSurvey
     * @param {object} form
     * @return {Promise<*>}
     */
    storeSurvey = async ( form ) => {
        const {selectedSurvey, survey_type, userType} = this.state;

        const lastQuestionId = selectedSurvey[ selectedSurvey.length - 1 ].id;
        if ( !form.results[ lastQuestionId - 1 ] ) {
            form.results[ lastQuestionId - 1 ] = 'N/A';
        }

        // if (!form.results || this.questions.some(q => q.type !== 'text' && !form.results[q.id])) {
        //     setAlert('error', 'You must provide an answer to every question.', []);
        //     setWorking(false);
        //     return null;
        // }

        let results = Object.entries ( form.results ).map ( ( result, key ) => {
            return {
                question: result[ 0 ].toString (),
                answer: result[ 1 ].toString (),
            };
        } );

        return SurveyAPI.store ( {
            survey: this.state.survey,
            survey_type: survey_type,
            results: results,
            user_group: userType ?? null,
        } );
    }

    /**
     * @method renderEventValueQuestion
     * @param {string} question
     * @return {JSX.Element}
     */
    renderEventValueQuestion = (question) => {
        const { form } = this.props;
        const selectedValue = form.results && form.results[question.id-1] ? form.results[question.id-1] : '';

        const handleRadioChange = (question, value) => {
            this.updateResults(question.id - 1, value);
        };

        return (
            <div className="my-2">
            {question.options.map(option => (
                <div key={option.value} className="flex mt-1">
                    <input
                        type="radio"
                        id={`${question.id}-${option.value}`}
                        name={`question-${question.id}`}
                        checked={selectedValue === option.value}
                        onChange={() => handleRadioChange(question, option.value)}
                        className="h-5 w-5 text-indigo-600 transition duration-150 ease-in-out rounded-lg border hover:border-gray-600 focus:ring-0 focus:outline-none focus:ring-offset-0 cursor-pointer -mt-1"
                    />
                    <Label
                        label={option.label}
                        htmlFor={`${question.id}-${option.value}`}
                        className="ml-2 text-md flex -mt-1"
                    />
                </div>
            ))}
        </div>
        );
    }

    /**
     * @method renderSuccess
     * @return {JSX.Element}
     */
    renderSuccess() {
        return <div className="p-4 md:p-8 text-center py-10 px-5 md:px-10 mb-10 ">
                    <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                        <h1 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase text-app-blue">
                            Thank you for your submission
                        </h1>
                    </div>
                </div>;
    }

    /**
     * @method renderSurvey
     * @return {JSX.Element}
     */
    renderSurvey() {
        const { handleSubmit, resetAlert, working, alert } = this.props;

        const { loading, submission, question, selectedSurvey, userType } = this.state;

        if ( loading ) {
            return <Loading />;
        }

        if ( submission) {
            return this.renderSuccess();
        }

        if(!selectedSurvey) {
            return <>
                <div className="p-4 md:p-8 text-center py-10 px-5 md:px-10 mb-10 ">
                    <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                        <h1 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                            Survey not available
                        </h1>
                    </div>
                </div>
            </>
        }

        return (
            <>
            <h3 className="text-center text-3xl mx-8 lg:mt-20 mb-12 font-bold uppercase">
                Question {question}
            </h3>

            <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                {!loading && !submission && (
                    <form onSubmit={(e) => handleSubmit(e, this.storeSurvey, this.success, true)}>
                        {alert && <Alert {...alert} />}

                        {selectedSurvey.map((q, index) => (
                            question === q.id && (
                                <div key={q.id}>
                                    {q.text}
                                    <br />
                                    {q.type === 'scale' && this.renderSurveyScaleA(index)}
                                    {q.type === 'text' && this.renderTextInput(index)}
                                    {q.type === 'boolean' && this.renderSurveyScaleBoolean(index)}
                                    {q.type === 'numeric' && this.renderSurveyScaleNumeric(index)}
                                    {q.type === 'numericTen' && this.renderSurveyScaleNumericTen(index)}
                                    {q.type === 'eventValue' && this.renderEventValueQuestion(q)}
                                </div>
                            )
                        ))}

                        <div className={`mt-4 flex ${question === 1 ? 'justify-end' : 'justify-between'}`}>
                            {question !== 1 && (
                                <PrimaryButton
                                    working={working}
                                    onClick={() => {
                                        resetAlert();
                                        this.setState({ question: +question - 1 });
                                    }}
                                    text="Previous"
                                />
                            )}

                            {question !== selectedSurvey.length && (
                                <PrimaryButton
                                    working={working}
                                    onClick={async () => {
                                        resetAlert ();
                                        const currentQuestion = selectedSurvey.find ( q => q.id === question );
                                        const currentQuestionType = currentQuestion.type;

                                        if ( currentQuestionType === 'text' && !this.props.form.results[ question - 1 ] ) {
                                            await this.updateResults ( question - 1, 'N/A' );
                                            this.setState ( { question: +question + 1 } );
                                        }

                                        if ( this.props.form.results[ question - 1 ] !== undefined ) {
                                            this.setState ( { question: +question + 1 } );
                                        }
                                    }}
                                    type="button"
                                    text="Next"
                                />
                            )}

                            {question === selectedSurvey.length && (
                                <PrimaryButton
                                    working={working}
                                    text="Submit"
                                />
                            )}
                        </div>
                    </form>
                )}
            </div>
        </>
        );
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { handleSubmit, resetAlert, working, alert } = this.props;

        const { loading, submission, question } = this.state;

        return (
            <Authenticated>
                { working && <Loading/> }

                { !working && submission &&
                    (this.renderSuccess())
                }

                { !working && !submission &&
                    (this.renderSurvey())
                }
            </Authenticated>
        );
    }

    /**
     * @method renderSurveyScaleA
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleA = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 5, 'excellent')}
                {this.renderRadioButton(question, 4, 'very good')}
                {this.renderRadioButton(question, 3, 'good')}
                {this.renderRadioButton(question, 2, 'not very good')}
                {this.renderRadioButton(question, 1, 'poor')}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleB
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleB = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 5, 'strongly agree')}
                {this.renderRadioButton(question, 4, 'agree')}
                {this.renderRadioButton(question, 3, 'neutral')}
                {this.renderRadioButton(question, 2, 'disagree')}
                {this.renderRadioButton(question, 1, 'strongly disagree')}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleNumeric
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleNumeric = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 1, 1)}
                {this.renderRadioButton(question, 2, 2)}
                {this.renderRadioButton(question, 3, 3)}
                {this.renderRadioButton(question, 4, 4)}
                {this.renderRadioButton(question, 5, 5)}
{/*/!*                {this.renderRadioButton(question, 6, 6)}*/}
{/*                {this.renderRadioButton(question, 7, 7)}*/}
{/*                {this.renderRadioButton(question, 8, 8)}*/}
{/*                {this.renderRadioButton(question, 9, 9)}*/}
{/*                {this.renderRadioButton(question, 10, 10)}*!/*/}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleNumericTen
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleNumericTen = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 1, 1)}
                {this.renderRadioButton(question, 2, 2)}
                {this.renderRadioButton(question, 3, 3)}
                {this.renderRadioButton(question, 4, 4)}
                {this.renderRadioButton(question, 5, 5)}
                {this.renderRadioButton(question, 6, 6)}
                {this.renderRadioButton(question, 7, 7)}
                {this.renderRadioButton(question, 8, 8)}
                {this.renderRadioButton(question, 9, 9)}
                {this.renderRadioButton(question, 10, 10)}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleBoolean
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleBoolean = (question) => {
        return (
            <div className="m-8 p-3 w-max mx-auto flex flex-col md:flex-row gap-12">
                {this.renderRadioButton(question, 'Yes', 'Yes')}
                {this.renderRadioButton(question, 'No', 'No')}
            </div>
        );
    }

    /**
     * @method renderRadioButton
     * @param {string} question
     * @param {string} answer
     * @param {string} label
     * @return {JSX.Element}
     */
    renderRadioButton = (question, answer, label) => {
        const { form } = this.props;

        let checked = form.results && form.results[question] ? (form.results[question] === answer) : false;

        return (
            <div className={'flex flex-col items-center w-max w-full gap-2 mx-auto'}>
                <input
                    type="checkbox"
                    id={question + '-' + answer}
                    checked={checked}
                    onChange={() => this.updateResults(question, answer)}

                    className={`
                        h-5 w-5 text-indigo-600 transition duration-150 ease-in-out rounded-lg
                        border hover:border-gray-600 focus:ring-0 focus:outline-none  focus:ring-offset-0 mx-auto cursor-pointer
                        ${checked ? ' bg-app-blue focus:ring-0 border-app-blue text-app-blue' : 'border-gray-500'}
                    `}
                    radioGroup={label}
                />

                <Label label={label} htmlFor={question + '-' + answer} className="mb-0 text-center capitalize text-md" />
            </div>
        )
    }

    /**
     * @method renderSelectBar
     * @param {string} question
     * @param {string} options
     * @return {JSX.Element}
     */
    renderSelectBar = (question, options) => {
        const { form } = this.props;

        let selectedValue = form.results && form.results[question] ? form.results[question] : null;

        return (
            <div className="my-2">
                <ReactSelect
                    value={selectedValue ? options.filter(n => n.value === selectedValue)[0] : null}
                    options={options}
                    onChange={(option) => this.updateResults(question, option.value)}
                    isSearchable={false}
                />
            </div>
        );
    }

    /**
     * @method renderTextInput
     * @param {string} question
     * @return {JSX.Element}
     */
    renderTextInput = (question) => {
        const { form } = this.props;

        let value = form.results && form.results[question] ? form.results[question] : '';

        return (
            <input
                type="text"
                value={ value }
                onChange={ ( e ) => this.updateResults ( question, e.target.value ) }
                className="bg-white border-b border-black text-black adobe-reg w-full my-8"
            />
        );
    }
};

export default withRouter(FormHandler ( Survey ));
